import { ExternalLink, Sparkles } from "lucide-react";
import axios from "axios";
import { useWaitlist, getContact } from "@/lib/waitlist";
import { API } from "@/App";

const recordInterest = (resultId, cta) => {
  const c = getContact();
  if (!c.email || !resultId) return;
  axios.post(`${API}/results/${resultId}/interest`, { item_key: cta.item_key, email: c.email, first_name: c.firstName || null }).catch(() => {});
};

export const CtaButton = ({ cta, testId, variant = "solid" }) => {
  const { ready, open, resultId } = useWaitlist();
  if (!cta?.url) return null;
  const cls = `${variant === "solid" ? "fea-btn" : "fea-btn-outline"} no-print`;
  if (cta.kind === "waitlist" && ready[cta.item_key]) {
    return (
      <button onClick={() => open(cta)} className={cls} data-testid={testId}>
        <Sparkles className="h-4 w-4" /> {cta.label}
      </button>
    );
  }
  return (
    <a href={cta.url} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}
      onClick={cta.kind === "enroll" ? () => recordInterest(resultId, cta) : undefined}>
      {cta.label} <ExternalLink className="h-4 w-4" />
    </a>
  );
};
